import * as React from 'react';
import type { UserStatus } from '@klareospace/pharos-lib-types';

import { STATUS_BADGE_COLORS, STATUS_BADGE_SOLID_COLORS } from '../status-badge';
import { StatusBadge } from '../status-badge';

export const USER_STATUS_STYLES: Record<UserStatus, string> = {
  active: STATUS_BADGE_COLORS.success,
  inactive: STATUS_BADGE_COLORS.warning,
  pending: STATUS_BADGE_COLORS.info,
};

export const USER_STATUS_SOLID_STYLES: Record<UserStatus, string> = {
  active: STATUS_BADGE_SOLID_COLORS.success,
  inactive: STATUS_BADGE_SOLID_COLORS.warning,
  pending: STATUS_BADGE_SOLID_COLORS.info,
};

export interface UserStatusBadgeProps {
  /** Optional additional CSS classes */
  className?: string;
  /** The translated label to show inside the badge */
  label: string;
  /** Whether to use solid filled style instead of light outline */
  solid?: boolean;
  /** The user status to display */
  status: UserStatus;
}

export function UserStatusBadge({ className, label, solid = false, status }: UserStatusBadgeProps): React.JSX.Element {
  const styles = solid ? USER_STATUS_SOLID_STYLES : USER_STATUS_STYLES;
  return <StatusBadge className={className} label={label} status={status} styles={styles} />;
}
